import { render, staticRenderFns } from "./CMContactDetail.vue?vue&type=template&id=017ff98f&"
import script from "./CMContactDetail.vue?vue&type=script&lang=js&"
export * from "./CMContactDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('017ff98f')) {
      api.createRecord('017ff98f', component.options)
    } else {
      api.reload('017ff98f', component.options)
    }
    module.hot.accept("./CMContactDetail.vue?vue&type=template&id=017ff98f&", function () {
      api.rerender('017ff98f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/contacts/CMContactDetail.vue"
export default component.exports